export var KEY_SPACE = 32;
export var KEY_ENTER = 13;
export var KEY_ESC = 27;
export var KEY_BACKSPACE = 8;
export var KEY_UP = 38;
export var KEY_DOWN = 40;
export var KEY_LEFT = 37;
export var KEY_RIGHT = 39;
export var isKbInteraction = function isKbInteraction(e) {
  return [KEY_ENTER, KEY_SPACE].includes(e.keyCode);
};
export var isKbDismiss = function isKbDismiss(e) {
  return e.keyCode === KEY_ESC;
};
export var keyUpEvent = function keyUpEvent(e) {
  return e.keyCode === KEY_UP;
};
export var keyDownEvent = function keyDownEvent(e) {
  return e.keyCode === KEY_DOWN;
};
export var keyLeftEvent = function keyLeftEvent(e) {
  return e.keyCode === KEY_LEFT;
};
export var keyRightEvent = function keyRightEvent(e) {
  return e.keyCode === KEY_RIGHT;
};